// eslint-disable-next-line @typescript-eslint/no-unused-vars, import/no-named-default
import { default as SimpleLightbox } from 'simplelightbox/dist/simple-lightbox.modules';

// lightbox
// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unused-vars, @typescript-eslint/no-unsafe-call
const lightbox = new SimpleLightbox('.img-gallery a', { overlayOpacity: 0.85, captionSelector: 'self' });
